import { InventoryItemType } from 'src/app/core/enums/inventory-item-type.enum';
import { CompanySalesOrderStatus } from 'src/app/core/models/sales/company-sales-order-status.type';

export type SalesOrdersStatusFilter = '' | CompanySalesOrderStatus | 'archived' | 'all';

export type SalesOrdersTypeFilter = '' | InventoryItemType;

export type SalesOrdersSourceFilter = '' | 'bc' | 'local';

export interface SalesOrdersFilterModel {
  statusFilter: SalesOrdersStatusFilter;
  typeFilter: SalesOrdersTypeFilter;
  sourceFilter: SalesOrdersSourceFilter;
}

export const SALES_ORDERS_FILTER_FIELDS = {
  Status: 'status',
  Type: 'type',
  Source: 'source',
} as const;

export interface SalesOrdersStatusOption {
  readonly value: SalesOrdersStatusFilter;
  readonly labelKey: string;
}

export const SALES_ORDERS_STATUS_OPTIONS: readonly SalesOrdersStatusOption[] = [
  { value: '', labelKey: 'COMPONENTS.SALES_ORDERS.FILTERS.STATUS_DEFAULT' },
  { value: 'Draft', labelKey: 'COMPONENTS.SALES_ORDERS.STATUSES.DRAFT' },
  { value: 'New', labelKey: 'COMPONENTS.SALES_ORDERS.STATUSES.NEW' },
  { value: 'Confirmed', labelKey: 'COMPONENTS.SALES_ORDERS.STATUSES.CONFIRMED' },
  { value: 'Cancelled', labelKey: 'COMPONENTS.SALES_ORDERS.STATUSES.CANCELLED' },
  { value: 'archived', labelKey: 'COMPONENTS.SALES_ORDERS.FILTERS.STATUS_ARCHIVED' },
  { value: 'all', labelKey: 'COMPONENTS.SALES_ORDERS.FILTERS.STATUS_ALL' },
];

export const SALES_ORDERS_TYPE_OPTIONS: readonly InventoryItemType[] = [
  'Product',
  'Service',
  'Hybrid',
];

export function createEmptySalesOrdersFilterModel(): SalesOrdersFilterModel {
  return {
    statusFilter: '',
    typeFilter: '',
    sourceFilter: '',
  };
}
